import { Skeleton } from "@/components/ui/skeleton";

export function LoadingScreen() {
  return (
    <div
      className="lx-route-loading min-h-dvh bg-background"
      role="status"
      aria-label="Loading page"
      style={{ minHeight: "100dvh", background: "hsl(var(--background, 0 0% 100%))" }}
    >
      {/* Branded header skeleton */}
      <div
        className="h-14 border-b bg-card/80 flex items-center px-4 gap-3"
        style={{ height: 56, display: "flex", alignItems: "center", gap: 12, paddingInline: 16 }}
      >
        <Skeleton className="w-8 h-8 rounded-lg" style={{ width: 32, height: 32 }} />
        <Skeleton className="h-4 w-28" style={{ width: 112, height: 16 }} />
      </div>
      {/* Content skeleton */}
      <div
        className="container mx-auto px-4 py-8 max-w-4xl"
        style={{ width: "100%", maxWidth: 896, marginInline: "auto", padding: "32px 16px" }}
      >
        <div className="space-y-4">
          <Skeleton className="h-6 w-64 mx-auto" style={{ width: "min(256px, 70vw)", height: 24, marginInline: "auto" }} />
          <Skeleton className="h-4 w-48 mx-auto" style={{ width: "min(192px, 55vw)", height: 16, margin: "16px auto 0" }} />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} className="h-48 rounded-2xl" style={{ height: 192, marginTop: 16 }} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
